import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

export default function NotreHistoire() {
  const { t } = useTranslation();
  const paragraphs = [t('ourStory.p1'), t('ourStory.p2'), t('ourStory.p3'), t('ourStory.p4'), t('ourStory.p5'), t('ourStory.p6')];

  return (
    <main data-testid="our-story-page">
      <section className="pt-20 pb-12 lg:pt-28 lg:pb-16 bg-ivory text-center">
        <div className="max-w-3xl mx-auto px-4 animate-fade-up">
          <div className="text-[11px] tracking-luxury uppercase text-gold mb-4">MSK Watch</div>
          <h1 className="font-serif text-4xl md:text-6xl font-light" data-testid="our-story-title">{t('ourStory.title')}</h1>
        </div>
      </section>

      <section className="pb-24 lg:pb-32">
        <div className="max-w-2xl mx-auto px-4 lg:px-8 space-y-6">
          {paragraphs.map((p, i) => (
            <p key={i} className={`leading-relaxed text-[#333] ${i === 0 ? 'font-serif text-xl md:text-2xl text-[#1A1A1A] font-light' : 'text-sm md:text-base text-[#555]'}`}>
              {p}
            </p>
          ))}
        </div>
      </section>
    </main>
  );
}
